import { Descriptions, Divider, Space } from "@/atoms"

import styles from "./MetaRow.module.scss"

import type { MetaRowComponent } from "."

export const MetaRow: MetaRowComponent = ({ items }) => {
  return (
    <Space
      separator={<Divider orientation="vertical" className="m-0-divider-ks" />}
      className={styles.container}
    >
      {items.map(({ label, children }, index) => (
        <div key={index} className={styles.item}>
          <Descriptions.Label>{label}</Descriptions.Label>
          <Descriptions.Label>{children}</Descriptions.Label>
        </div>
      ))}
    </Space>
  )
}
